import { useEffect } from 'react';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const LittleRedLine = () => {
  useEffect(() => {
    const redLines = gsap.utils.toArray('.little-red-line-js');

    redLines.forEach((elem) => {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          x: -20
        },
        {
          scrollTrigger: {
            trigger: elem,
            start: 'top bottom'
            // markers: true
          },
          autoAlpha: 1,
          x: 0,
          delay: 0.5
        }
      );
    });
  }, []);

  return <div className="w-16 h-1 bg-red mb-10 little-red-line-js"></div>;
};
export default LittleRedLine;
